<div class="container-fluid" id="container-wrapper" *ngIf="userType=='Admin'">
    <div class="d-sm-flex align-items-center justify-content-between mb-4" style="border-bottom:2px solid grey;">
        <div class="col">
            <h1 class="h3 mb-0 text-gray-800">Lead Conditions</h1>
        </div>
        <div class="col" style="float: right;right:-10px;max-width: 280px;">
            <button class="float" (click)="openAddDialog()"><i class="fas fa-plus"></i></button>
        </div>
    </div>
    <div class="row" id="dataArea" #dataArea style="position: fixed;overflow-y: scroll !important;overflow-x: hidden;height: 570px;width: 100%;">
        <div class="div-viewport">
            <div class="grid12">
                <table class="table table-sm table-hover " style="padding-right: 20px!important;">
                    <tr style="background-color: blue;color: white;">
                        <th>#</th>
                        <th>Condition Name</th>
                        <th>If Source</th>
                        <th>Then assign to</th>
                        <th>Assign Method</th>
                        <th>Leads at a Time</th>
                        <th></th>
                    </tr>
                    <tbody id="myTable">
                        <tr *ngFor="let item of pagedItems;let counter=index;">
                            <td>{{counter+1}}</td>
                            <td>{{item.conditionName}}</td>
                            <td>{{item.source}}</td>
                            <td>{{item.userName}}</td>
                            <td>{{item.assignLead}}</td>
                            <td>{{item.leadsAtATime}}</td>
                            <th style="max-width: 20px!important;">
                                <li class="nav-item dropdown no-arrow mx-1" style="right: 12px;margin-top: -10px;">
                                    <a class="nav-link" href="#" id="alertsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right shadow " aria-labelledby="alertsDropdown">
                                        <a class="dropdown-item d-flex align-items-center" (click)="openEditDialog(item.refNo)">
                                            <div class="mr-3">
                                                <div class="icon-circle bg-success">
                                                    <i class="fas fa-edit text-white"></i>
                                                </div>
                                            </div>
                                            <div>
                                                Edit Lead Condition
                                            </div>
                                        </a>
                                        <a class="dropdown-item d-flex align-items-center" (click)="deleteData(item.refNo)">
                                            <div class="mr-3">
                                                <div class="icon-circle bg-warning">
                                                    <i class="fas fa-male text-white"></i>
                                                </div>
                                            </div>
                                            <div>
                                                Delete Lead Condition
                                            </div>
                                        </a>
                                    </div>
                                </li>
                            </th>
                        </tr>
                        <tr>
                            <th colspan="6" *ngIf="pagedItems?.length==0">No data found !</th>
                        </tr>
                    </tbody>
                </table>
                <div class="pagination-wrapper">
                    <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                            <a (click)="setPage(1)">First</a>
                        </li>
                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                            <a (click)="setPage(pager.currentPage - 1)">Prev</a>
                        </li>
                        <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                            <a (click)="setPage(page)">{{page}}</a>
                        </li>
                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                            <a (click)="setPage(pager.currentPage + 1)">Next</a>
                        </li>
                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                            <a (click)="setPage(pager.totalPages)">Last</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>